import { render } from "./ArticlesSection.vue?vue&type=template&id=9253863c"
import script from "./ArticlesSection.vue?vue&type=script&lang=js"
export * from "./ArticlesSection.vue?vue&type=script&lang=js"

import "./ArticlesSection.vue?vue&type=style&index=0&id=9253863c&lang=scss"
script.render = render

export default script